//THIS FILE IS WRITTEN ONLY FOR COMPILATION
// Core
import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import { TranslateModule } from "@ngx-translate/core";
// Components
import { AppComponent } from './app.component';
import { FakeloaderComponentModule } from '@signature-it/ngx-generic/components/fakeloader';


@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        RouterModule,
        FakeloaderComponentModule
    ],
    declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent]
})
export class AppModuleGeneric { }
